import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../commonFunctions";
  
  const beneficiary = {
    label: "Beneficiary Module",
    pageLabel: "Beneficiary Module",
    starting: true,
    url: "beneficiary",
    pageType: "history",
    formTabs: {
      allTabs: [
        {
          label: "General",
          uid: "create",
          style: { fontFamily: "verdana" }
        }
      ]
    },
    filter:[
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Circle",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        tab:'filter',
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getCircleName",
            fieldType: "string",
            filters: ["pageData", "circlename"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Circle",
        name: "circle",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-6",
          children: "col-lg-12"
        },
        label: "",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Sub Circle",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        tab:'filter',
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getSubCircleName",
            fieldType: "string",
            filters: ["pageData", "subcirclename"],
            dependsOn:[{circle:"circle.value"}]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Sub Circle",
        name: "subCircle",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-6",
          children: "col-lg-12"
        },
        label: "",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Work Date",
        description: ""
      },
      {
          inputType: "date",
          dateType: "ontype",
          tab:'filter',
          isRequired: true,
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          placeHolder: "Work Date",
          displayFormat: "DD/MM/YYYY",
          outputFormat: "YYYYMMDD",
          name: "workdate",
          description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-6",
          children: "col-lg-12"
        },
        label: "",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Work Status",
        description: ""
      },
      {
          inputType: "select",
          tab:'filter',
          default: "",
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          options: [
            {
              label: "Completed",
              value: "completed"
            },
            {
              label: "In Progress",
              value: "inProgress"
            },
            {
              label: "Not Completed",
              value: "notCompleted"
            },
            {
              label: "Stop",
              value: "stop"
            },
                            
          ],
          placeHolder: "Work Status",
          name: "workstatus",
          description: ""
         },
         {
          inputType: "displaytext",
          tab:'filter',
          widths: {
            parent: "col-lg-6",
            children: "col-lg-12"
          },
          label: "",
          description: ""
        },
        {
          inputType: "displaytext",
          tab:'filter',
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "No Of Records",
          description: ""
        },
        {
          inputType: "numberonly",
          tab:'filter',
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "",
          placeHolder: "Per Page",
          name: "per_page",
          description: ""
        },
    ],
    form: [
      {
        inputType: "displaytext",
        tab:'create',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Circle",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        tab:'create',
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getCircleName",
            fieldType: "string",
            filters: ["pageData", "circlename"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Circle",
        name: "circle",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'create',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Sub Circle",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        tab:'create',
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getSubCircleName",
            fieldType: "string",
            // We assume that we are only going to use value for findthis
            dependsOn:[{circle:"circle.value"}],
            filters: ["pageData", "subcirclename"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Sub Circle",
        name: "subCircle",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'create',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Village",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        tab:'create',
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getVillageEle",
            fieldType: "string",
            dependsOn:[{circle:"circle.value"},{subCircle:"subCircle.value"}],
            filters: ["pageData", "VillageEle"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Village",
        name: "village",
        description: ""
      },
        {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Voter Search",
            description: ""
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            // deepSearch:true,
            // deepSearchData:"village.value",
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getVoterName",
                fieldType: "string",
                filters: ["pageData", "VoterName"],
                dependsOn:[{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Voter Search",
            name: "VoterID",
            description: ""
        },
        {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Department",
            description: ""
          }, 
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getDeptBeneficiary",
                fieldType: "string",
                filters: ["pageData", "DeptBeneficiary"],
                
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Department",
            name: "department",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Scheme",
            description: ""
          }, 
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getSchemeBeneficiary",
                fieldType: "string",
                filters: ["pageData", "SchemeBeneficiary"],
                dependsOn:[{department:"department.value"}]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Scheme",
            name: "scheme",
            description: ""
          },
          {
            inputType: "displaytext",
            // 
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Details of Work",
            description: ""
          },   
          {
            inputType: "text",
            tab:'create',
            widths: {
              parent: "col-lg-10",
              children: "col-lg-12"
            },
            placeHolder: "Details of Work",
            name: "detailsofWork",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Work Date",
            description: ""
          },
          {
              inputType: "date",
              dateType: "ontype",
              tab:'create',
              isRequired: true,
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Work Date",
              displayFormat: "DD/MM/YYYY",
              outputFormat: "YYYYMMDD",
              name: "workdate",
              description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Amount in Rs.",
            description: ""
          },
          {
            inputType: "numberonly",
            tab:'create',
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            placeHolder: "Amount in Rs.",
            name: "amount",
            description: ""
          },













          

         
    ],
    history: {
      perPage: 10,
      displayColumns: [
        {
          Header: "Voter",
          accessor: "VoterID.value",
        },
        {
          Header: "Department",
          accessor: "department.value",
        },
        {
          Header: "Scheme",
          accessor: "scheme.value",
        },
        {
          Header: "Work Date",
          accessor: "workdate.label",
        },
        {
          Header: "Amount",
          accessor: "amount",
        },
        
        
       
      ]
    },
  report: {
      perPage: 10,
      queryType: "mysqlQuery",
      //   groupBy: ["schedule","subschedule"],
      query: [
        {
          dialect: "mysql",
          seq: 1,
          columnHeader: [
            {
              id: "balance1",
              headerText: "trdate",
              headerFrom: "balance"
            }
          ],
          query: ""
        }
      ],
      displayColumns: [
        {
            Header: "Voter",
            accessor: "VoterID.value",
          },
          {
            Header: "Department",
            accessor: "department.value",
          },
          {
            Header: "Scheme",
            accessor: "scheme.value",
          },
          {
            Header: "Work Date",
            accessor: "workdate.label",
          },
          {
            Header: "Amount",
            accessor: "amount",
          },
        
      ]
    }
  }
  export default beneficiary;